"use strict";

export function initInScope($scope) {
    let $select = $scope.find('.js-checkout-country__country-select');
    let $deliverySelect = $scope.find('.js-checkout-country__delivery-country');

    let selectedCountry = _config.currentSelectedCountry;
    let selectedCountryDelivery = _config.currentSelectedCountry;

    try {
        selectedCountry = sessionStorage.getItem('countrySelect') || _config.currentSelectedCountry;
        selectedCountryDelivery = sessionStorage.getItem('countrySelectDelivery') || sessionStorage.getItem('countrySelect') || _config.currentSelectedCountry;
    } catch (e) {}

    if (selectedCountry) {
        $select.val(selectedCountry);
        if(!sessionStorage.getItem('countrySelect')){
            sessionStorage.setItem('countrySelect', selectedCountry);
        }
        if(selectedCountryDelivery){
            $deliverySelect.val(selectedCountryDelivery);
            if(!sessionStorage.getItem('countrySelectDelivery')){
                sessionStorage.setItem('countrySelectDelivery', selectedCountryDelivery);
            }
        }
    }

    $select.on('change', function (e) {
        if(!$(this).hasClass('js-checkout-country__delivery-country')){
            try {
                sessionStorage.setItem('countrySelect', $(this).val());
            } catch (e) {}
        }else{
            try {
                sessionStorage.setItem('countrySelectDelivery', $(this).val());
            } catch (e) {}
        }

        if($('.js-add-form-section__checkbox').attr('data-show-delivery-form') === 'true'){
            try {
                $(this).trigger('country-changed', sessionStorage.getItem('countrySelectDelivery'));
                _config.currentSelectedCountry = sessionStorage.getItem('countrySelectDelivery');
            } catch (e) {}
        }else{
            $(this).trigger('country-changed', $(this).val());
            _config.currentSelectedCountry = $(this).val();
        }
    });
}
